import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { cssInterop } from "nativewind";
import React from 'react';
import i18n from 'i18n-js';
import CalendarPicker from 'react-native-calendar-picker';
import Moment from "moment";
import CancelButton from "@/components/basic/CancelButton";
import ModalBase from '@/components/basic/ModalBase';
import { IconM } from '@/components/media/IconsV2';

cssInterop(CalendarPicker, {
//   customeTextClassName: { target: 'textStyle', nativeStyleToProp: { backgroundColor: true }  },

  textClassName: { target: "textStyle" },
  todayTextClassName: { target: "todayTextStyle" },

  monthTitleClassName: { target: "monthTitleStyle" },
  yearTitleClassName: { target: "yearTitleStyle" },

  selectedDayClassName: { target: "selectedDayStyle" },
//   selectedDayClassName: {
//     target: "selectedDayStyle",
//     nativeStyleToProp: { backgroundColor: "selectedDayColor" },
//   },
  selectedDayTextClassName: {
    target: "selectedDayTextStyle",
    nativeStyleToProp: { color: "selectedDayTextColor" },
  },
});

export default function ModalCalendar({ showModal, setShowModal, date, onDateChange, onMonthChange, customDatesStyles }) {

    const onDateChangeLocal = (date) => {
        onDateChange(date)
        setShowModal(false)
    }

    return (
        <ModalBase showModal={showModal} alignItems='center' h='h-[65%]'>
            <Text className="text-2xl text-secondary-900 self-center">{Moment(date).format('dddd, DD. MMMM YYYY')}</Text>
                <CalendarPicker
                    textClassName="text-lg font-medium text-secondary-900"
                    monthTitleClassName="font-bold text-secondary-900 text-lg"
                    yearTitleClassName="font-bold text-secondary-900 text-lg"

                    selectedDayClassName="bg-primary-900"
                    selectedDayTextClassName="text-secondary-50"

                    todayTextClassName={`font-bold text-lg ${Moment().isSame(Moment(date), 'day') ? 'text-secondary-50' : 'text-primary-900'}`}
                    todayBackgroundColor='none'                    

                    customDatesStyles={customDatesStyles}
               
                    previousComponent={<IconM className="ml-10 text-secondary-900" name="keyboard-arrow-left" />}
                    nextComponent={<IconM className="ml-10 text-secondary-900" name="keyboard-arrow-right" />}
                    selectMonthTitle={i18n.t('calendar.selectMonth')}
                    selectYearTitle={i18n.t('calendar.selectYear')}
                    weekdays={[i18n.t('calendar.mon'), i18n.t('calendar.tue'), i18n.t('calendar.wed'), i18n.t('calendar.thu'), i18n.t('calendar.fri'), i18n.t('calendar.sat'), i18n.t('calendar.sun')]}
                    months={[i18n.t('calendar.january'), i18n.t('calendar.february'), i18n.t('calendar.march'), i18n.t('calendar.april'), i18n.t('calendar.may'), i18n.t('calendar.june'), i18n.t('calendar.july'), i18n.t('calendar.august'), i18n.t('calendar.september'), i18n.t('calendar.october'), i18n.t('calendar.november'), i18n.t('calendar.december')]}
                    startFromMonday={true}
                    scaleFactor={425}
                    initialDate={date}
                    selectedStartDate={date}
                    onDateChange={onDateChangeLocal}
                    onMonthChange={onMonthChange}
                    // allowRangeSelection={false}
                />
            <View className="w-full absolute bottom-6 self-center">
                <CancelButton onPress={() => { setShowModal(false) }} text={i18n.t('calendar.cancel')} />
            </View>
        </ModalBase>
    );
}